import type React from 'react';

import { Box, Heading, Icon, Text } from '@zillow/constellation-10';
import { IconAwardRibbonFilled, IconMegaphoneFilled } from '@zillow/constellation-icons';

import { containerRecipe } from './styles';

type Props = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  header?: string | null;
  isPremiumTip?: boolean;
};

const WizardTipCard = ({
  icon = <IconMegaphoneFilled />,
  children = null,
  header = null,
  isPremiumTip = false,
}: Props) => (
  <Box css={containerRecipe.raw({ isPremiumTip })}>
    <Box css={{ marginBottom: '400' }}>
      {isPremiumTip ? (
        <>
          <Icon
            render={<IconAwardRibbonFilled />}
            size="sm"
            css={{ color: 'icon.accent.brand.hero', verticalAlign: 'middle' }}
          />
          <Text textStyle="body-sm-bold" css={{ color: 'text.accent.brand.hero' }} asChild>
            <span> Premium</span>
          </Text>
        </>
      ) : (
        <Icon render={icon} size="xl" css={{ color: 'icon.express.trust.hero' }} />
      )}
    </Box>

    {header && (
      <Box css={{ marginBottom: '400' }}>
        <Heading level={6} id="tip-title">
          {header}
        </Heading>
      </Box>
    )}

    {children}
  </Box>
);

export default WizardTipCard;
